import Vue from 'vue'
import VueTippy, { TippyComponent } from 'vue-tippy'

export default function (context) {
  Vue.use(VueTippy)
  Vue.component('Tippy', TippyComponent)
}
